<template lang="pug">

  section.thanks
    .container
      .loading(v-if="loading && !submitted" key="loading")
        Circle9
      .submitted(v-if="submitted" key="submitted")
        h1 ¡Gracias!
      .form(v-if="!loading" key="form")
        h1 {{getScoreTexts.number}}
        .percentage
          h2.number {{getScoreTexts.title}}
          h3.quote {{getScoreTexts.quote}}
        p Ingresa tus datos para participar por entradas
        iframe(src="https://www.surveygizmo.com/s3/4538961/TriviaPeugeot", frameborder="0" width="100%" height="400")

      Sharer(:title="getScoreTexts.title" :content="getScoreTexts.quote" v-if="!loading || submitted")

</template>

<script>
  import { mapGetters } from 'vuex'
  import { Circle9 } from 'vue-loading-spinner'
  import { Validator } from 'vee-validate'
  import axios from 'axios'
  import Sharer from '@/components/trivia/Sharer'

  export default  {
    name: 'thanks',
    components: {
      Circle9,
      Sharer
    },
    data: () => ({
      lead: {
        email: ''
      },
      loading: false,
      submitted: false
    }),
    mounted(){
      this.$ga.event('trivia', 'finished', this.getScoreTexts.number)
    },
    methods: {
      validateBeforeSubmit (e) {
        e.preventDefault()
        this.loading = true
        this.$validator.validateAll().then(result => {
          if(result) {
            axios.post('https://formback.laboratoriodecontenidos.cl/api/trivia/store', this.lead).then(response => {
              this.submitted = true
            }).catch(err => {
              this.loading = false
              // console.log('error', err)
            })
          } else {
            this.loading = false
            // console.log('error2')
          }
        }).catch(err => {
          this.loading = false
          // console.log('error3', err)
        })
      }
    },
    computed: {
      ...mapGetters([
        'getScoreTexts'
      ])
    }
}
</script>

<style scoped lang="scss">
  .thanks {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100%;
  }
  .container{
    text-align: center;
  }
  form{
    display: flex;
    align-items: stretch;
    justify-content: center;
    input{
      font-size: 1.6rem;
      padding: 1rem;
      border: 1px solid red;
      background-color: white;
      @media screen and (max-width: 500px){
        width: 50%;
      }
    }
    button{
      font-size: 1rem;
      padding: 1rem 2rem;
      background-color: red;
      color: black;
      border: 1px solid black;
      letter-spacing: 0.2rem;
      cursor: pointer;
    }
  }
  h1{
    font-size: 3rem;
  }
  h2{
    font-size: 2rem;
  }
  h3{
    font-size: 1.6rem;
  }
  p{
    font-size: 1rem;
  }
  .error{
    border-color: #9F3A38;
    background-color: lighten(#9F3A38, 50%);
  }
  .loading,
  .submitteds{
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to{
    transform: translateX(60px);
    opacity: 0;
  }


</style>
